import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    pageNameList: [], // 页面标题
    cancelTokens: {}, // 要取消的请求集合
  },
  mutations: {
    // 增加要取消的请求
    addCancel(state, option) {
      state.cancelTokens[option.keyName] = option.cancel
    },
    // 删除要取消的请求
    removeCancel(state, key) {
      Object.keys(state.cancelTokens).forEach((cancelFnKey, index) => {
        if (cancelFnKey.indexOf(key) > -1) {
          delete state.cancelTokens[Object.keys(state.cancelTokens)[index]]
        }
      })
    },
    // 取消请求  请求有设置了 cancelTag 传 cancelTag  没有则传 api的key
    cancelReq(state, key) {
      let cancelIndex = -1
      Object.keys(state.cancelTokens).forEach((cancelFnKey, index) => {
        if (key == 'all') {
          state.cancelTokens[cancelFnKey] && state.cancelTokens[cancelFnKey]()
        } else {
          if (cancelFnKey.indexOf(key) > -1) {
            cancelIndex = index
            state.cancelTokens[cancelFnKey] && state.cancelTokens[cancelFnKey]()
          }
        }
      })
      if (key == 'all') {
        state.cancelTokens = {}
      } else {
        if (cancelIndex > -1) {
          delete state.cancelTokens[
            Object.keys(state.cancelTokens)[cancelIndex]
          ]
        }
      }
    },
  },
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js